module.exports = __webpack_public_path__ + "static/media/design2.88aaed5c.png";